import { useAuthStore } from '@/stores/authStore';

/**
 * Whether the current trader may open the StreamRift Cockpit (Larry).
 * Resolved relay-side (GET /api/trader/me → `cockpitAccess`, from
 * traderRules.cockpitEnabled — fail-closed) and threaded onto the session by
 * refreshMe(). Defaults to false so the surface never leaks before access
 * lands. The relay enforces the same flag on /api/larry/* — display gating only.
 */
export function useCockpitAccess(): boolean {
  return useAuthStore((s) => s.user?.cockpitAccess ?? false);
}
